import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSearchPageLoading } from '../../../../../../selectors/searchPage';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { DTNoResultsLink } from '../../../../Common/DTNoResultsLink/DTNoResultsLink';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import { loadInfoForSelectedOrderItems } from '../../../../../../actions/tools/DecisionTree/OrderActions';

const DTSelectOrderAndLineItemsWithNoResultMacroNode = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectSearchPageLoading);
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);

  const handleNextButtonClick = () => {
    dispatch(loadInfoForSelectedOrderItems());
  };

  return (
    <CustomNoResultsComponentContextProvider value={<DTNoResultsLink />}>
      <DTOrderSearchView
        onNextButtonClick={handleNextButtonClick}
        isNextButtonActive={hasLineItemsSelected && !isLoading}
      />
    </CustomNoResultsComponentContextProvider>
  );
};
export default DTSelectOrderAndLineItemsWithNoResultMacroNode;
